// Accesos abiertos recientemente desde el menú de un módulo.
//
// Se guardan SOLO en el equipo del usuario (localStorage), no en el servidor: es una comodidad
// de navegación, no información del negocio. Todas las lecturas van protegidas porque el
// almacenamiento puede estar bloqueado (modo incógnito, políticas del navegador) o traer datos
// corruptos de una versión anterior.
//
// Creado: 2026-09-17 — IA (Claude)

const MAXIMO_POR_DEFECTO = 4;
const LARGO_MAXIMO_TITULO = 120;

const claveAlmacenamiento = (idmodulo) => `hd_accesos_recientes_modulo_${idmodulo}`;

// Nunca se confía en lo que viene de localStorage: se valida forma y se recorta el texto.
const esAccesoValido = (item) =>
  item &&
  typeof item === "object" &&
  typeof item.titulo === "string" &&
  typeof item.ruta === "string" &&
  item.ruta.startsWith("/");

const sanitizar = (acceso) => ({
  titulo: String(acceso.titulo).slice(0, LARGO_MAXIMO_TITULO),
  ruta: String(acceso.ruta),
  fecha: typeof acceso.fecha === "string" ? acceso.fecha : new Date().toISOString(),
});

export const obtenerAccesosRecientes = (idmodulo, maximo = MAXIMO_POR_DEFECTO) => {
  try {
    const crudo = localStorage.getItem(claveAlmacenamiento(idmodulo));
    if (!crudo) return [];

    const lista = JSON.parse(crudo);
    if (!Array.isArray(lista)) return [];

    return lista.filter(esAccesoValido).map(sanitizar).slice(0, maximo);
  } catch (error) {
    return [];
  }
};

export const registrarAccesoReciente = (idmodulo, acceso, maximo = MAXIMO_POR_DEFECTO) => {
  if (!esAccesoValido(acceso)) return obtenerAccesosRecientes(idmodulo, maximo);

  try {
    const previos = obtenerAccesosRecientes(idmodulo, maximo * 2);
    const sinRepetir = previos.filter((item) => item.ruta !== acceso.ruta);
    const actualizados = [sanitizar({ ...acceso, fecha: new Date().toISOString() }), ...sinRepetir].slice(0, maximo);

    localStorage.setItem(claveAlmacenamiento(idmodulo), JSON.stringify(actualizados));
    return actualizados;
  } catch (error) {
    // Si el almacenamiento falla (cuota llena o bloqueado) la navegación debe continuar igual.
    return obtenerAccesosRecientes(idmodulo, maximo);
  }
};

export const limpiarAccesosRecientes = (idmodulo) => {
  try {
    localStorage.removeItem(claveAlmacenamiento(idmodulo));
  } catch (error) {
    // Sin acción: no es crítico.
  }
};

// "hoy" / "ayer" / "hace 3 días" / "12 sep" — se compara por día calendario, no por horas.
export const describirFechaRelativa = (fechaISO) => {
  try {
    const fecha = new Date(fechaISO);
    if (Number.isNaN(fecha.getTime())) return "";

    const inicioDe = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const dias = Math.round((inicioDe(new Date()) - inicioDe(fecha)) / 86400000);

    if (dias <= 0) return "hoy";
    if (dias === 1) return "ayer";
    if (dias < 7) return `hace ${dias} días`;

    return fecha.toLocaleDateString("es-MX", { day: "numeric", month: "short" });
  } catch (error) {
    return "";
  }
};
